import routerOptions0 from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}